<div class="desktop:mx-auto desktop:max-w-6.5xl z-10 bg-white">
  @if (tabList().length) {
    <div
      #mobileScrollMenu
      class="desktop:hidden overflow-x-auto text-black flex bg-white h-16 tablet:h-18 whitespace-nowrap text-mobileMd tablet:text-tabletMd scroll-smooth px-4"
    >
      @for (tab of tabList(); track tab.id) {
        <button
          class="flex items-center justify-center px-4 tablet:px-10 border-b-grayed-400 border-b-2 font-light"
          [ngClass]="{
            'border-b-2 border-b-black font-semibold': selectedTab()?.title === tab.title,
            'border-b border-b-grayed-400': selectedTab()?.title !== tab.title,
          }"
          (click)="selectTabMobile(tab)"
        >
          {{ tab.title }}
        </button>
      }
    </div>
    <div class="hidden desktop:block">
      <ngx-horizontal-scroll-menu
        #scrollMenu
        [items]="tabList()"
        [text]="'text-black whitespace-nowrap'"
        [distance]="distance"
        (clickedEventEmiiter)="selectTab($event)"
      >
      </ngx-horizontal-scroll-menu>
    </div>
  }
</div>
